(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Handle quantity updates
  document.querySelectorAll('.quantity-input').forEach(input => {
    input.addEventListener('change', function () {
      if (this.value == 0) {
        // Remove item if quantity is 0
        const lineItem = this.closest('[data-line-item]')
        if (lineItem) {
          lineItem.remove()
        }
      }
      // Submit form to update cart
      document.getElementById('cart-form').submit()
    })
  })

  // Handle remove buttons
  document.querySelectorAll('[data-remove-item]').forEach(button => {
    button.addEventListener('click', function () {
      const index = this.getAttribute('data-remove-item')
      const input = document.getElementById(`quantity-${index}`)
      if (input) {
        input.value = 0
        document.getElementById('cart-form').submit()
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Custom Filter Dropdown Element
  class FilterDropdown extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[js-filter-toggle]')
      this.arrow = this.querySelector('[js-filter-arrow]')
      this.dropdown = this.querySelector('[js-filter-dropdown]')
      this.label = this.querySelector('[js-filter-label]')
      this.radios = this.querySelectorAll('.filter-radio')
      this.isOpen = false

      // Toggle dropdown
      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.toggleDropdown())
      }
      if (this.arrow) {
        this.arrow.addEventListener('click', () => this.toggleDropdown())
      }

      // Close on outside click
      document.addEventListener('click', e => {
        if (!this.contains(e.target) && this.isOpen) {
          this.closeDropdown()
        }
      })

      // Handle radio change
      this.radios.forEach(radio => {
        radio.addEventListener('change', e => {
          if (e.target.checked) {
            // Get the label text
            const label = e.target.nextElementSibling
            if (label && label.textContent) {
              // Extract and clean the label text
              const labelText = label.textContent.trim()
              const cleanLabelText = labelText.replace(/ \(\d+\)$/, '') // Remove count from label

              // Only update if we have valid text
              if (cleanLabelText) {
                this.label.textContent = cleanLabelText
              }
            }

            // Close dropdown
            this.closeDropdown()

            // Submit form
            this.submitForm()
          }
        })
      })
    }

    toggleDropdown() {
      this.isOpen ? this.closeDropdown() : this.openDropdown()
    }

    openDropdown() {
      this.isOpen = true
      this.dropdown.classList.add('is-open')
      this.arrow.querySelector('svg').style.transform = 'rotate(180deg)'
    }

    closeDropdown() {
      this.isOpen = false
      this.dropdown.classList.remove('is-open')
      this.arrow.querySelector('svg').style.transform = 'rotate(0deg)'
    }

    async submitForm() {
      const form = this.closest('form')
      if (!form) return

      // Store current label text to preserve it during async operations
      const currentLabelText = this.label.textContent

      const formData = new FormData(form)
      const url = new URL(form.action)

      // Clear existing search params
      url.search = ''

      // Add non-empty form values to URL
      for (let [key, value] of formData.entries()) {
        if (value && value.trim() !== '') {
          url.searchParams.set(key, value)
        }
      }

      // Update browser URL without reload
      window.history.pushState({}, '', url.toString())

      // Ensure label stays updated during loading
      this.label.textContent = currentLabelText

      // Show loading state
      this.showLoadingState()

      try {
        // Fetch the filtered collection HTML
        const response = await fetch(url.toString())
        const html = await response.text()

        // Parse the response
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        // Update products section
        const newProductsSection = doc.querySelector('#products-section')
        const currentProductsSection =
          document.querySelector('#products-section')

        if (newProductsSection && currentProductsSection) {
          // Replace the entire section content (includes products and pagination)
          currentProductsSection.innerHTML = newProductsSection.innerHTML
        } else {
          // Fallback: try to update just the products grid
          const newGrid = doc.querySelector('.products-grid')
          const currentGrid = document.querySelector('.products-grid')
          if (newGrid && currentGrid) {
            currentGrid.innerHTML = newGrid.innerHTML
          }
        }

        // Pagination is already updated as part of the products section
        // No need for separate pagination update

        // Update product count if it exists
        const newCount = doc.querySelector('[js-products-count]')
        const currentCount = document.querySelector('[js-products-count]')
        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent
        }

        // Update all filter labels to reflect new state
        const newFilterDropdowns = doc.querySelectorAll('filter-dropdown')
        const currentFilterDropdowns =
          document.querySelectorAll('filter-dropdown')

        currentFilterDropdowns.forEach((dropdown, index) => {
          const newDropdown = newFilterDropdowns[index]
          if (newDropdown) {
            const newLabel = newDropdown.querySelector('[js-filter-label]')
            const currentLabel = dropdown.querySelector('[js-filter-label]')
            if (newLabel && currentLabel && newLabel.textContent.trim()) {
              currentLabel.textContent = newLabel.textContent.trim()
            }

            // Update radio states
            const radios = dropdown.querySelectorAll('.filter-radio')
            radios.forEach(radio => {
              const newRadio = newDropdown.querySelector(
                `input[name="${radio.name}"][value="${radio.value}"]`
              )
              if (newRadio) {
                radio.checked = newRadio.checked
              }
            })
          }
        })

        // Reinitialize any JavaScript for new products
        this.reinitializeProductCards()
      } catch (error) {
        console.error('Error fetching filtered products:', error)
        // Fallback to page reload on error
        window.location.href = url.toString()
      } finally {
        this.hideLoadingState()
      }
    }

    showLoadingState() {
      // Add loading state to products section
      const productsSection = document.querySelector('#products-section')
      if (productsSection) {
        productsSection.style.opacity = '0.5'
        productsSection.style.pointerEvents = 'none'
        productsSection.style.transition = 'opacity 0.3s ease'
      }

      // Add spinner overlay
      const loadingOverlay = document.createElement('div')
      loadingOverlay.className =
        'loading-overlay fixed inset-0 bg-off-white/50 z-50 flex items-center justify-center'
      loadingOverlay.innerHTML = `
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dark-green"></div>
      `
      document.body.appendChild(loadingOverlay)
    }

    hideLoadingState() {
      // Remove loading state from products section
      const productsSection = document.querySelector('#products-section')
      if (productsSection) {
        productsSection.style.opacity = '1'
        productsSection.style.pointerEvents = 'auto'
      }

      // Remove loading overlay
      const loadingOverlay = document.querySelector('.loading-overlay')
      if (loadingOverlay) {
        loadingOverlay.remove()
      }
    }

    reinitializeProductCards() {
      // Reinitialize any JavaScript functionality for product cards
      // This might include lazy loading, quick view, etc.

      // Dispatch event for other scripts to know products have been updated
      window.dispatchEvent(new CustomEvent('products:updated'))
    }
  }

  customElements.define('filter-dropdown', FilterDropdown)

  // Mobile Filter Accordion
  class MobileFilterAccordion extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[js-mobile-filter-toggle]')
      this.options = this.querySelector('[js-mobile-filter-options]')
      this.arrow = this.querySelector('.mobile-filter-arrow')
      this.isOpen = false

      if (this.toggle && this.options) {
        this.toggle.addEventListener('click', () => {
          this.isOpen = !this.isOpen

          if (this.isOpen) {
            this.options.removeAttribute('hidden')
            if (this.arrow) {
              this.arrow.style.transform = 'rotate(180deg)'
            }
          } else {
            this.options.setAttribute('hidden', '')
            if (this.arrow) {
              this.arrow.style.transform = 'rotate(0deg)'
            }
          }
        })
      }
    }
  }

  customElements.define('mobile-filter-accordion', MobileFilterAccordion)

  // Mobile Filter Drawer
  class MobileFiltersDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = document.querySelector('[js-mobile-filters-toggle]')
      this.closeBtn = this.querySelector('[js-mobile-filters-close]')
      this.overlay = this.querySelector('[js-mobile-filters-overlay]')
      this.removeAllBtn = this.querySelector('[js-remove-all-filters]')
      this.form = this.querySelector('.mobile-filters-form')

      // Open drawer
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.openDrawer())
      }

      // Close drawer
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closeDrawer())
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeDrawer())
      }

      // Remove all filters
      if (this.removeAllBtn) {
        this.removeAllBtn.addEventListener('click', e => {
          this.removeAllFilters()
          this.handleSubmit(e) // run submit logic after removing filters
        })
      }

      // Handle form submission
      if (this.form) {
        this.form.addEventListener('submit', e => this.handleSubmit(e))
      }
    }

    openDrawer() {
      this.removeAttribute('hidden')
      document.body.style.overflow = 'hidden'
    }

    closeDrawer() {
      this.setAttribute('hidden', '')
      document.body.style.overflow = ''
    }

    removeAllFilters() {
      if (!this.form) return

      // Reset all radio buttons to "All" option
      const allRadios = this.form.querySelectorAll(
        'input[type="radio"][value=""]'
      )
      allRadios.forEach(radio => {
        radio.checked = true
      })

      // Reset sort to default
      const sortSelect = this.form.querySelector('select[name="sort_by"]')
      if (sortSelect) {
        sortSelect.selectedIndex = 0
      }
    }

    handleSubmit(e) {
      e.preventDefault()

      const formData = new FormData(this.form)
      const url = new URL(this.form.action)

      // Clear existing search params
      url.search = ''

      // Add non-empty form values to URL
      for (let [key, value] of formData.entries()) {
        if (value && value.trim() !== '') {
          url.searchParams.set(key, value)
        }
      }

      // Navigate to filtered URL
      window.location.href = url.toString()
    }
  }

  customElements.define('mobile-filters-drawer', MobileFiltersDrawer)

  // Handle browser back/forward buttons
  window.addEventListener('popstate', async event => {
    const url = new URL(window.location.href)

    try {
      // Show loading state
      const productsGrid = document.querySelector('.products-grid')
      if (productsGrid) {
        productsGrid.style.opacity = '0.5'
        productsGrid.style.pointerEvents = 'none'
      }

      // Fetch the page content
      const response = await fetch(url.toString())
      const html = await response.text()

      // Parse the response
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      // Update products grid
      const newProducts = doc.querySelector('.products-grid')
      const currentProducts = document.querySelector('.products-grid')
      if (newProducts && currentProducts) {
        currentProducts.innerHTML = newProducts.innerHTML
      }

      // Update pagination
      const newPagination = doc.querySelector('.pagination')
      const currentPagination = document.querySelector('.pagination')
      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML
      } else if (!newPagination && currentPagination) {
        currentPagination.remove()
      }

      // Update filter dropdowns to reflect current state
      const filterDropdowns = document.querySelectorAll('filter-dropdown')
      filterDropdowns.forEach(dropdown => {
        const radios = dropdown.querySelectorAll('.filter-radio')
        const label = dropdown.querySelector('[js-filter-label]')

        radios.forEach(radio => {
          const paramName = radio.name
          const value = radio.value
          const urlValue = url.searchParams.get(paramName) || ''

          if (value === urlValue) {
            radio.checked = true
            // Update label text
            if (label) {
              const radioLabel = radio.nextElementSibling.textContent
              label.textContent = radioLabel.replace(/ \(\d+\)$/, '')
            }
          }
        })
      })
    } catch (error) {
      console.error('Error handling browser navigation:', error)
      window.location.reload()
    } finally {
      // Hide loading state
      const productsGrid = document.querySelector('.products-grid')
      if (productsGrid) {
        productsGrid.style.opacity = '1'
        productsGrid.style.pointerEvents = 'auto'
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends window.HTMLElement {
    connectedCallback() {
      this.header = this.children[0]
      this.burger = this.querySelector('.burger')
      this.burgerClose = this.querySelector('.burger-close')
      this.thresholdEl = this
      this.currentScrollY = document.documentElement.scrollTop
      this.preventReveal = false
      this.resizeObserver = null
      this.burger?.addEventListener('click', this.onBurgerClick.bind(this))
      this.burgerClose?.addEventListener(
        'click',
        this.onBurgerCloseClick.bind(this)
      )
      window.addEventListener('scroll', this.onScroll.bind(this), false)
      this.setThreshold()
      this.reset()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler)
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal !== newVal) {
        this[name] = newVal
      }
      this.setThreshold()
    }

    setThreshold() {
      this.thresholdEl = this.header
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
      this.resizeObserver = new window.ResizeObserver(entries => {
        this.thresholdBounds = entries[0].contentRect
        this.header.classList.remove('is-mobile-menu')
      })
      this.resizeObserver.observe(this.thresholdEl)
      this.onScroll()
    }

    hideHeaderOnScrollUp() {
      this.preventReveal = true
    }

    onScroll() {
      const scrollY = window.scrollY
      const threshold =
        this.thresholdBounds || this.thresholdEl.getBoundingClientRect()
      this.pastThreshold(scrollY > threshold.bottom)
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return
      // Check if megamenu is open
      const megamenu = this.querySelector('megamenu-toggle')
      if (megamenu && megamenu.isOpen) {
        window.requestAnimationFrame(this.reveal.bind(this))
        this.currentScrollY = scrollY
        return
      }
      if (scrollY > this.currentScrollY && scrollY > threshold.bottom) {
        if (this.preventHide) return
        window.requestAnimationFrame(this.hide.bind(this))
      } else if (scrollY < this.currentScrollY && scrollY > threshold.bottom) {
        if (!this.preventReveal) {
          window.requestAnimationFrame(this.reveal.bind(this))
        } else {
          window.clearTimeout(this.isScrolling)
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false
          }, 10)
          window.requestAnimationFrame(this.hide.bind(this))
        }
      } else if (scrollY <= threshold.top) {
        window.requestAnimationFrame(this.reset.bind(this))
      }
      this.currentScrollY = scrollY
    }

    onBurgerClick(e) {
      e.preventDefault()
      this.header.classList.add('is-mobile-menu')
    }

    onBurgerCloseClick(e) {
      e.preventDefault()
      this.header.classList.remove('is-mobile-menu')
    }

    pastThreshold(isPast) {
      if (isPast) {
        this.header.classList.add('is-past-thresh')
        this.header.classList.remove('not-past-thresh')
      } else {
        this.header.classList.add('not-past-thresh')
        this.header.classList.remove('is-past-thresh')
      }
    }

    hide() {
      if (document.documentElement.classList.contains('overflow-hidden')) return
      this.header.classList.add('is-hidden')
      this.header.classList.remove('is-revealed')
    }

    reveal() {
      this.header.classList.add('is-revealed')
      this.header.classList.remove('is-hidden')
    }

    reset() {
      this.header.classList.add('is-revealed')
      this.header.classList.remove('is-hidden')
    }
  }

  window.customElements.define('sticky-header', StickyHeader)

  class MegamenuToggle extends window.HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[slot="trigger"]')
      this.content = this.querySelector('[slot="content"]')
      this.openIndicator = this.querySelector('.megamenu-open')
      this.closeIndicator = this.querySelector('.megamenu-close')
      this.isOpen = false
      this.scrollPosition = 0

      this.trigger?.addEventListener('click', this.toggle.bind(this))
      document.addEventListener('click', this.handleOutsideClick.bind(this))
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOutsideClick)
    }

    toggle(e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    }

    open() {
      this.isOpen = true
      this.content.classList.remove('hidden')

      // Save scroll position and prevent body scroll
      this.scrollPosition = window.pageYOffset
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.classList.add('megamenu-open')

      // Force header to stay revealed when megamenu is open
      const stickyHeader = this.closest('sticky-header')
      if (stickyHeader) {
        stickyHeader.reveal()
      }

      setTimeout(() => {
        this.content.classList.add('is-open')
        this.openIndicator.classList.add('hidden')
        this.closeIndicator.classList.remove('hidden')
        this.closeIndicator.classList.add('flex')
        this.trigger.setAttribute('aria-expanded', 'true')
      }, 10)
    }

    close() {
      this.isOpen = false
      this.content.classList.remove('is-open')
      this.openIndicator.classList.remove('hidden')
      this.closeIndicator.classList.add('hidden')
      this.closeIndicator.classList.remove('flex')
      this.trigger.setAttribute('aria-expanded', 'false')

      // Restore body scroll and position
      document.body.classList.remove('megamenu-open')
      document.body.style.top = ''
      // window.scrollTo(0, this.scrollPosition)
    }

    handleOutsideClick(e) {
      if (!this.contains(e.target) && this.isOpen) {
        this.close()
      }
    }
  }

  window.customElements.define('megamenu-toggle', MegamenuToggle)

  // Search functionality
  document.addEventListener('DOMContentLoaded', () => {
    const searchButtons = document.querySelectorAll('[js-open-search]')
    const closeSearchButtons = document.querySelectorAll('[js-close-search]')
    const searchBar = document.querySelector('[js-header-search]')
    const searchOverlay = document.querySelector('[js-search-overlay]')
    const searchInput = document.querySelector('[js-search-input]')

    function openSearch() {
      // Close megamenu if open
      const megamenuToggle = document.querySelector('megamenu-toggle')
      if (megamenuToggle && megamenuToggle.isOpen) {
        megamenuToggle.close()
      }

      if (searchBar && searchOverlay) {
        searchBar.classList.remove('hidden')
        searchBar.classList.add('flex')
        searchOverlay.classList.remove('hidden')
        // Focus the search input
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100)
        }
      }
    }

    function closeSearch() {
      if (searchBar && searchOverlay) {
        searchBar.classList.add('hidden')
        searchBar.classList.remove('flex')
        searchOverlay.classList.add('hidden')
        // Clear the search input
        if (searchInput) {
          searchInput.value = ''
        }
      }
    }

    searchButtons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        openSearch()
      })
    })

    closeSearchButtons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        closeSearch()
      })
    })

    // Close when clicking overlay
    if (searchOverlay) {
      searchOverlay.addEventListener('click', () => {
        closeSearch()
      })
    }

    // Close on Escape key
    document.addEventListener('keydown', e => {
      if (
        e.key === 'Escape' &&
        searchBar &&
        !searchBar.classList.contains('hidden')
      ) {
        closeSearch()
      }
    })
  })

  } catch(e) { console.error(e); }
})();
})();
